import styled from "styled-components";

export const RepeatBetContainer = styled.div`
  flex-direction: column;
  display: flex;
  overflow: auto;
  max-height: calc(100vh - 120px);
`;

export const BetSumaryContainer = styled.div`
  padding: 12px;
  position: relative;
`;

export const ButtonsContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 12px 12px;
  overflow: hidden;
  background-color: var(--fd-colors-background-surface);
`;

// a dummy element is used to prevent dropdown erratic behaviour
export const DummyElement = styled.div`
  height: 120px;
`;
